<div *ngIf="taxNumbers$ | async as taxNumbers; else loading">
  <div *ngIf="taxNumbers && taxNumbers.length > 0; else noData">
    <dx-data-grid
      [dataSource]="taxNumbers"
      [showBorders]="false"
      [columnAutoWidth]="true"
      [allowColumnReordering]="true"
      [allowColumnResizing]="true"
      [editing]="{
        mode: 'row',
        allowUpdating: true,
        useIcons: false
      }"
      (onRowUpdating)="onRowUpdating($event)">
      <dxo-editing
            mode="row"
          [allowUpdating]="true"
        >
        </dxo-editing>
        <dxo-scrolling mode="auto"></dxo-scrolling>

      <dxi-column dataField="countryId" caption="Tax Residency" width="150">
        <dxo-lookup [dataSource]="staticDataCountries$ | async" valueExpr="countryId" [displayExpr]="sharedService.formatCountry"></dxo-lookup>
      </dxi-column>

      <dxi-column dataField="taxNumber" caption="Tax Number"></dxi-column><dxi-column type="buttons" width="200" caption="Actions" [fixed]="true" fixedPosition="right">
        <dxi-button name="edit" template="editButtonTemplate">
          <ng-container *dxTemplate="let data of 'editButtonTemplate'">
            <ng-container *ngIf="!requireBothProductAndMemberEdit">
              <ng-container *appCheckPermission="null; permissions: ['member.edit']; requireLegalEntityContext: false">
                <dx-button
                    text="Edit"
                    stylingMode="contained"
                    type="default"
                    icon="">
                </dx-button>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="requireBothProductAndMemberEdit">
              <ng-container *appCheckPermission="null; permissions: ['member.edit']; requireLegalEntityContext: false">
                <ng-container *appCheckPermission="null; permissions: ['member.product.edit']; requireLegalEntityContext: false">
                  <dx-button
                      text="Edit"
                      stylingMode="contained"
                      type="default"
                      icon="">
                  </dx-button>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </dxi-button>

        <dxi-button name="save" template="saveButtonTemplate">
            <ng-container *dxTemplate="let data of 'saveButtonTemplate'">
                <dx-button style="margin-right:5px;"
                    text="Save"
                    stylingMode="contained"
                    type="success"
                    icon="">
                </dx-button>
            </ng-container>
        </dxi-button>

        <dxi-button name="cancel" template="cancelButtonTemplate">
          <ng-container *dxTemplate="let data of 'cancelButtonTemplate'">
              <dx-button
                  text="Cancel"
                  stylingMode="outlined"
                  type="danger"
                  icon="">
              </dx-button>
          </ng-container>
        </dxi-button>
      </dxi-column>
    </dx-data-grid>
  </div>
</div>
<ng-template #loading>
  <p>Loading tax numbers...</p>
</ng-template>
<ng-template #noData>
  <p>No tax numbers data available.</p>
</ng-template>